import { motion } from "framer-motion";
import React, { useEffect, useState } from "react";
//import Confetti from 'react-confetti';

const HeroSection = ({hasOffers}) => {
    const [showScrollHint, setShowScrollHint] = useState(true);
    //const [showConfetti, setShowConfetti] = useState(false);
    //const [showRibbon, setShowRibbon] = useState(true); 

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 50) {
                setShowScrollHint(false);
            } else {
                setShowScrollHint(true);
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const headingVariants = {
        hidden: { opacity: 0, y: -50, scale: 0.9 },
        visible: { opacity: 1, y: 0, scale: 1, transition: { duration: 0.8, ease: "easeOut" } },
    };

    const paragraphVariants = {
        hidden: { opacity: 0, y: 30 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.7, ease: "easeOut", delay: 0.4 } },
    };

    const buttonVariants = {
        hidden: { opacity: 0, scale: 0.8 },
        visible: { opacity: 1, scale: 1, transition: { duration: 0.6, ease: "easeOut", delay: 0.8 } },
    };

    const offerTextVariants = {
        hidden: { opacity: 0, y: -20 },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.6,
                ease: "easeOut",
                delay: 1.2, // Delay after other animations
            },
        },
        pulse: {
            scale: [1, 1.05, 1], // Pulsing effect
            opacity: [1, 0.8, 1], // Fading in and out slightly
            transition: {
                duration: 1.5,
                repeat: Infinity, // Keep repeating
                ease: "easeInOut",
            },
        },
    };
    /* Confetti party animation and welcome code*/
    // const triggerConfetti = () => {
    //         setShowConfetti(true);
    //         // Automatically turn off confetti after a few seconds
    //         setTimeout(() => {
    //             setShowConfetti(false);
    //         }, 8000); // Confetti will show for 3 seconds
    //     };
    
    //     // Main effect for sequence: Ribbon -> Confetti
    //     useEffect(() => {
    //         // Step 1: Show ribbon initially (already true by default)
    //         // Step 2: Hide ribbon after 2 seconds
    //         const ribbonTimeout = setTimeout(() => {
    //             setShowRibbon(false);
    //             // Step 3: Trigger confetti immediately after ribbon hides
    //             triggerConfetti();
    //         }, 2000); // Ribbon shows for 2 seconds
    
    //         // Cleanup function for useEffect
    //         return () => {
    //             clearTimeout(ribbonTimeout);
    //         };
    //     }, []); // Empty dependency array ensures it runs only once on mount

            //     {/* Confetti should appear AFTER the ribbon */}
            // {/* {showConfetti && (
            //     <Confetti
            //         width={window.innerWidth}
            //         height={window.innerHeight}
            //         numberOfPieces={2000}
            //         recycle={false}
            //         tweenDuration={5000}
            //     />
            // )}

            // {/* Ribbon Overlay - position it on top of everything */}
    // {showRibbon && (
    //             <motion.div
    //                 initial={{ opacity: 1 }}
    //                 animate={{ opacity: 0 }}
    //                 transition={{ delay: 1.5, duration: 0.5 }} // Fade out the ribbon
    //                 className="absolute inset-0 z-[999] flex items-center justify-center bg-pink-300 bg-opacity-90" // Dark overlay for the ribbon
    //             >
    //                 {/* You can use an image here or simply a div with background/border for a ribbon effect */}
    //                 <motion.div
    //                     initial={{ scaleX: 0 }}
    //                     animate={{ scaleX: 1 }}
    //                     transition={{ duration: 1, ease: "easeOut" }}
    //                     className="w-full h-12 bg-yellow-400 transform origin-left shadow-lg flex items-center justify-center font-bold text-xl text-pink-800"
    //                     style={{
    //                         clipPath: 'polygon(0% 0%, 100% 0%, 95% 50%, 100% 100%, 0% 100%)' // Simple ribbon cut
    //                     }}
    //                 >
    //                     Welcome!
    //                 </motion.div>
    //             </motion.div>
    //         )}

    return (
        <section id="hero" className="pt-16 relative w-full min-h-screen flex items-center justify-center bg-gradient-to-r from-pink-200 via-yellow-100 to-pink-100 overflow-hidden scroll-mt-16">     
            <div className="absolute top-0 left-0 w-72 h-72 bg-pink-300 rounded-full mix-blend-multiply filter blur-2xl opacity-30 animate-blob"></div>
            <div className="absolute top-0 right-0 w-72 h-72 bg-yellow-300 rounded-full mix-blend-multiply filter blur-2xl opacity-30 animate-blob animation-delay-2000"></div>
            <div className="absolute bottom-0 left-0 w-72 h-72 bg-pink-400 rounded-full mix-blend-multiply filter blur-2xl opacity-30 animate-blob animation-delay-4000"></div>

            <motion.div
                className="relative z-10 text-center px-4 md:px-10 lg:px-20"
                initial="hidden"
                animate="visible"
            >
                <motion.h1
                    className="text-4xl md:text-5xl lg:text-6xl font-bold text-pink-700"
                    variants={headingVariants}
                >
                    Welcome to A3 Creative Hub
                </motion.h1>
                <motion.p
                    className="mt-4 text-base md:text-lg lg:text-xl max-w-3xl mx-auto text-gray-800"
                    variants={paragraphVariants}
                >
                    Your one stop solution for return gifts and products at affordable price
                </motion.p>
                {hasOffers && ( // <--- Conditionally render the offer animation
                    <motion.p
                        className="mt-4 text-md md:text-2xl lg:text-2xl font-extrabold text-red-600 bg-yellow-300 inline-block px-4 py-2 rounded-lg shadow-lg"
                        variants={offerTextVariants}
                        initial="hidden"
                        animate={["visible", "pulse"]} // Play both visible and pulse animations
                    >
                        🎁 Offers Available Now on select Products! 🎉
                    </motion.p>
                )}
                <br/>
                {hasOffers && ( // <--- Conditionally render the offer animation
                    <motion.p
                        className="mt-4 text-md md:text-2xl lg:text-2xl font-extrabold text-red-600 bg-yellow-300 inline-block px-4 py-2 rounded-lg shadow-lg"
                        variants={offerTextVariants}
                        initial="hidden"
                        animate={["visible", "pulse"]} // Play both visible and pulse animations
                    >
                        🎁 Offers Valid till July 31, 2025. Grab your products soon 🎉
                    </motion.p>
                )}
                <br/>
                <motion.a
                    href="#contact"
                    className="mt-8 inline-block bg-pink-500 hover:bg-pink-600 transition px-6 py-3 md:px-8 md:py-4 text-white rounded-full shadow-lg hover:shadow-xl transform hover:scale-105 duration-300 text-sm md:text-base"
                    variants={buttonVariants}
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                >
                    Let’s Celebrate Together 🎉
                </motion.a>
            </motion.div>

            {showScrollHint && (
                <div className="absolute bottom-16 md:bottom-6 left-1/2 transform -translate-x-1/2 opacity-80 transition-opacity duration-1000">
                    <a href="#products" className="flex flex-col items-center text-black animate-bounce">
                        <div className="w-6 h-10 border-2 border-black rounded-full flex items-start justify-center">
                            <div className="w-1 h-2 bg-black rounded-full mt-1 animate-ping" />
                        </div>
                        <span className="text-xs font-semibold mt-2">Scroll</span>
                    </a>
                </div>
            )}
        </section>
    );
};

export default HeroSection;
